import { useParams } from "react-router-dom";
import { PatientForm } from "@/features/patients/PatientForm";

export default function PatientFormPage() {
  const { id } = useParams();
  return (
    <div className="mx-auto max-w-7xl p-6">
      <PatientForm patientId={id} />
    </div>
  );
}
